import { useEffect, useState } from "react";

export function useShowLabelsButton(): boolean {
  const [showLabels, setShowLabels] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.key === "Alt" || e.key === "Option") && !e.repeat) {
        e.preventDefault();
        setShowLabels(true);
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === "Alt" || e.key === "Option") {
        setShowLabels(false);
      }
    };

    const handleBlur = () => {
      setShowLabels(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  return showLabels;
}
